import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-escola-curso")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-escola-curso"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-escola-curso"]!.metaDescription,
    path: "/agente-ia-escola-curso",
  }),
  component: () => <SegmentRoute slug="agente-ia-escola-curso" />,
});
